// extracted by mini-css-extract-plugin
module.exports = {"AwardsCarousel":"styles_AwardsCarousel__rDSzW","height":"styles_height__U3BAh"};